import React, { createContext, useState, useContext, useEffect } from 'react';
import authService from '../services/auth.service';
import { ROLES } from '../utils/constants';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkUser();
  }, []);

  const checkUser = async () => {
    try {
      const savedUser = authService.getCurrentUser();
      if (savedUser) {
        setUser(savedUser);
      }
    } catch (error) {
      console.error('❌ Erreur check user:', error);
    } finally {
      setLoading(false);
    }
  };

  const login = async (email, password) => {
    try {
      const data = await authService.login(email, password);
      
      if (!data || !data.user) {
        throw new Error('Données utilisateur invalides');
      }

      setUser(data.user);
      console.log('✅ User set:', data.user);
      
      return data.user;
    } catch (error) {
      console.error('❌ Login error:', error);
      throw error;
    }
  };

  const logout = async () => {
    console.log('🚪 Logging out...');
    try {
      await authService.logout();
    } catch (error) {
      console.error('❌ Logout error:', error);
    } finally {
      // ✅ TOUJOURS nettoyer, même en cas d'erreur
      setUser(null);
      console.log('✅ Logged out, user cleared');
    }
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
};